import {IHomeListItem} from "../../model/IHomeListItem";
import {byDate} from "../../utils/dateUtil";

export const getThreeMostRecent = (homeItems: IHomeListItem[]): IHomeListItem[] => {
    return homeItems
        .sort(byDate)
        .slice(0, 3);
};
